var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreReleaseCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7333 14.6667V6.13333C31.7333 5.56754 31.5086 5.02492 31.1085 4.62484C30.7084 4.22476 30.1658 4 29.6 4H6.13333C5.56754 4 5.02492 4.22476 4.62484 4.62484C4.22476 5.02492 4 5.56754 4 6.13333V27.4667C4 28.0325 4.22476 28.5751 4.62484 28.9752C5.02492 29.3752 5.56754 29.6 6.13333 29.6H14.6667",
    stroke: "#121212",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 24.2669C13.4727 24.2669 14.6666 23.073 14.6666 21.6003C14.6666 20.1275 13.4727 18.9336 11.9999 18.9336C10.5272 18.9336 9.33325 20.1275 9.33325 21.6003C9.33325 23.073 10.5272 24.2669 11.9999 24.2669Z",
    stroke: "#121212",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 21.5999V11.9373C14.6668 11.4895 14.8077 11.053 15.0696 10.6898C15.3315 10.3266 15.7011 10.055 16.1259 9.91346L22.5259 8.13568C22.8466 8.02888 23.188 7.9998 23.5221 8.05082C23.8562 8.10184 24.1734 8.23151 24.4476 8.42914C24.7218 8.62678 24.945 8.88672 25.099 9.18756C25.2531 9.48841 25.3334 9.82153 25.3334 10.1595V14.6665",
    stroke: "#121212",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.535 19L29.4512 24.8975H35.6523L30.6355 28.5424L32.5517 34.44L27.535 30.7951L22.5183 34.44L24.4345 28.5424L19.4177 24.8975H25.6188L27.535 19Z",
    stroke: "#121212",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreReleaseCustom);
export default __webpack_public_path__ + "static/media/pre-release-custom.6d8ee9e5.svg";
export { ForwardRef as ReactComponent };